module.exports = __webpack_public_path__ + "4fb0fadbebf8c4c6ad7dec1bf9dfce40.svg";